export default [
  {
    name: 'Райффайзен',
    logo: require('@/assets/partners/raif.svg'),
    href: '#'
  },
  {
    name: 'Газпромбанк',
    logo: require('@/assets/partners/gpb.svg'),
    href: '#'
  },
  {
    name: 'ВТБ',
    logo: require('@/assets/partners/vtb.svg'),
    href: '#'
  },
  {
    name: 'Сбер',
    logo: require('@/assets/partners/sber.svg'),
    href: '#'
  },
  {
    name: 'Альфа-банк',
    logo: require('@/assets/partners/alfa.svg'),
    href: '#'
  }
]
